module.exports = __webpack_public_path__ + "img/tui-1.b201379e.png";